import { render } from "./Features.vue?vue&type=template&id=a6d984e8&scoped=true&ts=true&lang=pug"
import script from "./Features.vue?vue&type=script&lang=ts"
export * from "./Features.vue?vue&type=script&lang=ts"

import "./Features.vue?vue&type=style&index=0&id=a6d984e8&scoped=true&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d984e8"]])

export default __exports__